const data = {
  'title': 'Programming Bitcoin - Rust',
  'content': 'A Bitcoin library in Rust inspired by Jimmy Song\'s Programming Bitcoin, designed for robust and efficient Bitcoin development.',
  'github': 'https://github.com/tigeryant/programming-bitcoin-rust',
  'live': '',
  'technologies': [
    'Rust',
    'Bitcoin',
  ],
}

export default data